module.exports = __webpack_public_path__ + "static/media/target-social.adab5c39.png";